import React, { useEffect } from 'react';

const PricingColumnsTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,pricingTableTabData }) => {

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/pricing-table/temp-css/PricingTableWidget.css`;
        if (widgetId) {
            link.setAttribute("pricing-table-data-dynamic-css", "pricing-table");
        } else {
            link.setAttribute("data-dynamic-css", "pricing-table");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="pricing-table"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    return (
        <>
            <div className={`upgadeify pricing-table-pricing-columns-temp ${pricingTableTabData.is_website_frontend}`}>
                 <div className='pricing_table_grid'>
                    <div className="panel pricing-table">
                        <div>
                            <img src="/pricing-table/templates/standard.png" alt="" className="pricing-img" />
                            <div className="pricing-plan">
                            <h2 className="pricing-header" style={{ color: "#000" }}>Standard Room</h2>
                            <p style={{ color: "#111", fontSize:"12px" }}>1 full bed</p>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Private Bathroom</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Mini Refrigerator</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Flat-screen TV</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>
                                In-Room Heating and A/C Controls</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Hairdryer</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>High Speed Free WiFi</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Iron and Ironing Board</li>
                            </ul>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>From $99 <small style={{ color: "#000", fontSize:"16px" }}>/ night</small></span>
                            <a href="#/" className="pricing-button">Pay monthly</a>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>No booking or credit card fees!</span>
                        </div>
                        </div>
                       
                        <div>
                            <img src="/pricing-table/templates/doubleroom.png" alt="" className="pricing-img" />
                            <div className="pricing-plan">
                            <h2 className="pricing-header" style={{ color: "#000" }}>Double Room</h2>
                            <p style={{ color: "#111", fontSize:"12px" }}>2 full beds</p>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Private Bathroom</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Mini Refrigerator</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Flat-screen TV</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>
                                In-Room Heating and A/C Controls</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Hairdryer</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>High Speed Free WiFi</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Iron and Ironing Board</li>
                            </ul>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>From $99 <small style={{ color: "#000", fontSize:"16px" }}>/ night</small></span>
                            <a href="#/" className="pricing-button">Pay monthly</a>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>No booking or credit card fees!</span>
                        </div>
                        </div>
                        <div>
                            <img src="/pricing-table/templates/kingroom.png" alt="" className="pricing-img" />
                            <div className="pricing-plan">
                            <h2 className="pricing-header" style={{ color: "#000" }}>King Room</h2>
                            <p style={{ color: "#111", fontSize:"12px" }}>1 king bed</p>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Private Bathroom</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Mini Refrigerator</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Flat-screen TV</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>
                                In-Room Heating and A/C Controls</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Hairdryer</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>High Speed Free WiFi</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}>Iron and Ironing Board</li>
                            </ul>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>From $99 <small style={{ color: "#000", fontSize:"16px" }}>/ night</small></span>
                            <a href="#/" className="pricing-button">Pay monthly</a>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>No booking or credit card fees!</span>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default PricingColumnsTemplateWidget;
